'use strict';

import { createFetch } from '@vueuse/core';
import { getCurrentUser } from 'vuefire';
import router from '../router/app-router';

/**
 * Composable function for making API calls
 */
export const useFetch = createFetch({
  baseUrl: import.meta.env.VITE_API_HOST,
  options: {
    async beforeFetch({ options }) {
      // Get logged in user
      const firebaseUser = await getCurrentUser();

      // If user is logged in add token to request
      if (firebaseUser) {
        const token = await firebaseUser.getIdToken();
        options.headers.Authorization = `Bearer ${token}`;
      }

      return { options };
    },
    onFetchError(instance) {
      switch (instance.response?.status) {
        case 403:
          instance.error = 'Unauthorized to perform action';

          router.push({ name: 'access' });
          return instance;
          //break;
      }
      console.error('Fetch error caught in onFetchError:', instance);

      // You can modify the error object if needed
      instance.error = new Error(instance.data.detail);

      // You can also modify the data if you want to provide a fallback
      // if (ctx.data === null) {
      //   ctx.data = { message: 'Fallback data due to error' };
      // }

      // Return the context to continue the error handling process
      return instance;
    },
  },
  fetchOptions: {
    mode: 'cors',
  },
});
